import {
    DateFnsAdapter,
    MAT_DATE_FNS_FORMATS,
} from '@angular/material-date-fns-adapter';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

import {
    OVERLAY_DEFAULT_CONFIG,
    OverlayDefaultConfig,
} from '@angular/cdk/overlay';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { enGB } from 'date-fns/locale';
import { DatePickerIntl } from '../services/date-picker-intl';
import { DatePickerIntlService } from '../services/date-picker-intl.service';
import { MatPaginatorIntlService } from '../services/mat-paginator-intl.service';
import { EventModifierPluginProviders } from './event-modifier-plugin-providers';

/**
 * Providers which are required in both Admin portal and Client portal
 */
export const PlatformProviders = [
    ...EventModifierPluginProviders,
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlService },
    { provide: MAT_DATE_LOCALE, useValue: enGB },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    {
        provide: DateAdapter,
        useClass: DateFnsAdapter,
        deps: [MAT_DATE_LOCALE, MAT_DATE_FORMATS],
    },
    DatePickerIntlService,
    { provide: MatDatepickerIntl, useClass: DatePickerIntl }, // Custom translation for Angular Material Datepicker
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: { appearance: 'outline', floatLabel: 'always' }, // All form field are outlined and have floating label
    },
    // Gracefully stolen from https://www.reddit.com/r/angular/comments/1qqfd3u/comment/o2g9jnp/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button
    {
        provide: OVERLAY_DEFAULT_CONFIG,
        useValue: { usePopover: false } satisfies OverlayDefaultConfig,
    },
];
